export enum DeductionDisabilityCarePflegegrad {
  PFLEGEGRAD_2 = 2,
  PFLEGEGRAD_3 = 3,
  PFLEGEGRAD_4_5 = 4,
}
